import { render, staticRenderFns } from "./AlimTalkDev.vue?vue&type=template&id=ef3d6aa6&scoped=true"
import script from "./AlimTalkDev.vue?vue&type=script&lang=js"
export * from "./AlimTalkDev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3d6aa6",
  null
  
)

export default component.exports